const PageContentHeader = ({children}: {children: React.ReactNode}) => {
    return (
        <div className="flex items-center justify-center border-b border-yellow-40">
            {children}
        </div>
    )
}

export default PageContentHeader
